import { createSlice } from '@reduxjs/toolkit';
import { AreYouStillHereState } from '../are-you-still-here.state';

const initialState: AreYouStillHereState = {
    isOpened: false,
    expirationDate: new Date(),
};

const areYouStillHere = createSlice({
    name: 'areYouStillHere',
    initialState,
    reducers: {
        setIsOpened(state, action) {
            state.isOpened = action.payload;
        },
        setExpirationDate(state, action) {
            state.expirationDate = action.payload;
        },
    },
});

export const { setIsOpened, setExpirationDate } = areYouStillHere.actions;
export default areYouStillHere.reducer;
